module.exports = __webpack_public_path__ + "img/dribble.366b9f78.svg";